// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global google, citymariehamn */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        smallWidth: 702,
        largeWidth: 1007,
        companiesToShow: [],
        allCompanyCategories: [],

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Sub menu
         */
        __handleSubMenu: function() {
            wntrTheme.body.on('click', '.toggle-submenu-button', function() {
                wntrTheme.body.find('.header').toggleClass('header--mobile-sub-menu-active');
            });

            wntrTheme.body.on('mouseover', '.header-desktop-nav .menu-item-has-children', function() {
                $(this).addClass('menu-item-has-children--active');
            });

            wntrTheme.body.on('mouseout', '.header-desktop-nav .menu-item-has-children', function() {
                $(this).removeClass('menu-item-has-children--active');
            });
        },

        /**
         * Matchheight
         */
        __doMatchHeight: function() {
            if (wntrTheme.body.find('.grid-images-links-puff-small').length > 0) {
                wntrTheme.body.find('.grid-images-links-puff-small').matchHeight({
                    byRow: false,
                });
            }


            if (wntrTheme.body.find('.shop-card').length > 0) {
                wntrTheme.body.find('.front, .back').matchHeight({
                    byRow: false,
                    target: wntrTheme.body.find('.shop-card')
                });
            }

            if (wntrTheme.body.find('.news-preview-excerpt').length > 0) {
                wntrTheme.body.find('.news-preview-excerpt').matchHeight();
            }

            if ($(window).width() >= wntrTheme.smallWidth && wntrTheme.body.find('.shop-card-logo-wrapper').length > 0) {
                wntrTheme.body.find('.shop-card-logo-wrapper').matchHeight();
            }

            if ($(window).width() >= wntrTheme.smallWidth && wntrTheme.body.find('.shop-card-content').length > 0) {
                wntrTheme.body.find('.shop-card-content').matchHeight();
            }

            if ($(window).width() >= wntrTheme.smallWidth && wntrTheme.body.find('.about-intro').length > 0) {
                wntrTheme.body.find('.about-intro-description').matchHeight({
                    target: wntrTheme.body.find('.about-intro-links')
                });

                wntrTheme.body.find('.about-large-image').matchHeight({
                    target: wntrTheme.body.find('.about-intro')
                });

                $.fn.matchHeight._afterUpdate = function() {
                    wntrTheme.body.find('.about-large-image, .about-intro-description, .about-intro-links').animate({
                        opacity: 1
                    }, 200);
                };
            }

            if ($(window).width() >= wntrTheme.smallWidth && wntrTheme.body.find('.about-membership-benefits').length > 0) {
                wntrTheme.body.find('.about-membership-benefits li').matchHeight();
            }
        },

        /**
         * Google maps
         */
        __initGoogleMaps: function() {
            if (wntrTheme.body.find('#gmap').length > 0) {
                const locations = [];
                $.each(citymariehamn.markers, function(index, item) {
                    locations.push([
                        item.title,
                        item.lng,
                        item.lat
                    ]);
                });

                const zoom = 14;

                const map = new google.maps.Map(document.getElementById('gmap'), {
                    zoom: zoom,
                    disableDefaultUI: true,
                    center: citymariehamn.type === 'about' ? new google.maps.LatLng(locations[0][2], locations[0][1]) : new google.maps.LatLng(60.0995498, 19.9396796),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    // eslint-disable-next-line key-spacing
                    styles: [{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#747474"},{"lightness":"23"}]},{"featureType":"poi.attraction","elementType":"geometry.fill","stylers":[{"color":"#f38eb0"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"color":"#ced7db"}]},{"featureType":"poi.medical","elementType":"geometry.fill","stylers":[{"color":"#ffa5a8"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#c7e5c8"}]},{"featureType":"poi.place_of_worship","elementType":"geometry.fill","stylers":[{"color":"#d6cbc7"}]},{"featureType":"poi.school","elementType":"geometry.fill","stylers":[{"color":"#c4c9e8"}]},{"featureType":"poi.sports_complex","elementType":"geometry.fill","stylers":[{"color":"#b1eaf1"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":"100"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"},{"lightness":"100"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffd4a5"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffe9d2"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"weight":"3.00"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"weight":"0.30"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#747474"},{"lightness":"36"}]},{"featureType":"road.local","elementType":"labels.text.stroke","stylers":[{"color":"#e9e5dc"},{"lightness":"30"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":"100"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#d2e7f7"}]}]
                });

                const infowindow = new google.maps.InfoWindow();

                let marker;
                let i;

                for (i = 0; i < locations.length; i++) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i][2], locations[i][1]),
                        map: map
                    });

                    marker.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png');

                    google.maps.event.addListener(marker, 'click', (function(marker, i) {
                        return function() {
                            infowindow.setContent(
                                '<div class="gmaps-marker-info">' +
                                '<h2>' + locations[i][0] + '</h2>' +
                                '</div>'
                            );
                            infowindow.open(map, marker);
                        };
                    })(marker, i));
                }
            }
        },

        /**
         * Toggle mobile menu
         */
        __toggleMobileMenu: function() {
            wntrTheme.body.find('.header-toggle-mobile .hamburger').on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.header-mobile-nav').fadeToggle();
            });
        },

        /**
         * Fit text
         */
        __fitText: function () {
            if ($(window).width() <= wntrTheme.smallWidth) {
                $('.image-box-content h2:first-of-type, .image-box-content h3:first-of-type, .image-box-content h4:first-of-type, .image-box-content h5:first-of-type, .image-box-content h6:first-of-type, .image-box-content h1:first-of-type').fitText(1.8, { minFontSize: '18px', maxFontSize: '48px' });
            }
        },

        /**
         * Shop filters
         */
        __shopFilter: function () {
            if (wntrTheme.body.find('.page-section-shops').length > 0 || wntrTheme.body.find('.page-section-presentkort').length > 0) {
                // Toggle the map
                wntrTheme.body.find('.shops-toggle-map').on('click', function() {
                    $(this).toggleClass('show-map');
                    wntrTheme.body.find('.shop-map-view').slideToggle();
                });

                // Toggle grid view
                wntrTheme.body.find('.shops-toggle-grid').on('click', function() {
                    $(this).addClass('show-grid');
                    wntrTheme.body.find('.shop-card-view').slideDown();

                    // Toggle list view
                    wntrTheme.body.find('.shops-toggle-list').removeClass('show-list');
                    wntrTheme.body.find('.shop-list-view').slideUp();
                });

                // Toggle list view
                wntrTheme.body.find('.shops-toggle-list').on('click', function() {
                    $(this).addClass('show-list');
                    wntrTheme.body.find('.shop-list-view').slideDown();

                    // Toggle grid view
                    wntrTheme.body.find('.shops-toggle-grid').removeClass('show-grid');
                    wntrTheme.body.find('.shop-card-view').slideUp();
                });

                // Toggle shop list item
                wntrTheme.body.find('.shop-list-item-title').on('click', function() {
                    $(this).toggleClass('shop-show-info');
                    $(this).closest('.shop-list-item').find('.shop-list-item-info').slideToggle();
                });

                // Stick filter to the top of the screen on scroll
                if ($(window).width() <= wntrTheme.largeWidth && wntrTheme.body.find('.page-section-shops').length > 0) {
                    const distance = wntrTheme.body.find('.page-section-shops').offset().top - 90;

                    $(window).scroll(function() {
                        if ($(window).scrollTop() >= distance) {
                            wntrTheme.body.find('.shops-filter-wrapper').addClass('fixed-filters');
                            wntrTheme.body.find('.shop-category-filter-wrapper').addClass('fixed-filters');
                        } else {
                            wntrTheme.body.find('.shops-filter-wrapper').removeClass('fixed-filters');
                            wntrTheme.body.find('.shop-category-filter-wrapper').removeClass('fixed-filters');
                        }
                    });
                }

                // Show all shops
                wntrTheme.body.find('.shops-show-all-btn').on('click', function() {
                    $(this).addClass('filter-active');
                    wntrTheme.body.find('.shops-show-filters-btn').removeClass('filter-active');
                    wntrTheme.body.find('.shop-card').removeClass('hide-shop show-shop');
                    wntrTheme.body.find('.shop-list-item').removeClass('hide-shop show-shop');
                    wntrTheme.body.find('.shop-list-container').show();
                    wntrTheme.companiesToShow = [];
                    wntrTheme.body.find('.shop-category-filter-wrapper input').prop("checked", false);
                    wntrTheme.body.find('.shop-category-filter-wrapper').slideUp();
                });

                // Show the category filter wrapper
                wntrTheme.body.find('.shops-show-filters-btn').on('click', function() {
                    $(this).addClass('filter-active');
                    wntrTheme.body.find('.shops-show-all-btn').removeClass('filter-active');
                    wntrTheme.body.find('.shop-category-filter-wrapper').slideToggle();
                });

                wntrTheme.body.find('.shop-card').each(function() {
                    wntrTheme.allCompanyCategories.push($(this).data('term'));
                });

                // Filter the shop depending the the chosen filter
                wntrTheme.body.find('.shop-category-filter-wrapper input').on('click', function() {
                    const selected_category = $(this).val();

                    if ($(this).is(':checked')) {
                        wntrTheme.companiesToShow.push(selected_category);
                    } else {
                        wntrTheme.companiesToShow.splice($.inArray(selected_category, wntrTheme.companiesToShow), 1);
                    }

                    const companies_to_show = wntrTheme.allCompanyCategories.filter(function(val) {
                        // eslint-disable-next-line eqeqeq
                        return wntrTheme.companiesToShow.indexOf(val) != -1;
                    });

                    const companies_to_hide = wntrTheme.allCompanyCategories.filter(function(val) {
                        // eslint-disable-next-line eqeqeq
                        return wntrTheme.companiesToShow.indexOf(val) == -1;
                    });

                    for (let j = 0; j < companies_to_hide.length; j++) {
                        wntrTheme.body.find('.shop-card[data-term=' + companies_to_hide[j] + ']').removeClass('show-shop').addClass('hide-shop');
                        wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_hide[j] + ']').removeClass('show-shop').addClass('hide-shop');

                        if (wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_hide[j] + ']').closest('.shop-list-container').find('.shop-list-item').hasClass('hide-shop')) {
                            wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_hide[j] + ']').closest('.shop-list-container').hide();
                        }
                    }

                    for (let i = 0; i < companies_to_show.length; i++) {
                        wntrTheme.body.find('.shop-card[data-term=' + companies_to_show[i] + ']').removeClass('hide-shop').addClass('show-shop');
                        wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_show[i] + ']').removeClass('hide-shop').addClass('show-shop');

                        if (wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_show[i] + ']').closest('.shop-list-container').find('.shop-list-item').hasClass('show-shop')) {
                            wntrTheme.body.find('.shop-list-item[data-term=' + companies_to_show[i] + ']').closest('.shop-list-container').show();
                        }
                    }

                    // eslint-disable-next-line eqeqeq
                    if (wntrTheme.companiesToShow.length == 0) {
                        wntrTheme.body.find('.shop-card').removeClass('hide-shop show-shop');
                        wntrTheme.body.find('.shop-list-item').removeClass('hide-shop show-shop');
                        wntrTheme.body.find('.shop-list-container').show();
                    }
                });
            }
        },

        /**
         * Card flip
         */
        __cardFlip: function() {
            wntrTheme.body.find('.back-flip').on('click', function() {
                $(this).closest('.shop-card').toggleClass('flipped');
            });

            wntrTheme.body.find('.front').on('click', function() {
                $(this).closest('.shop-card').toggleClass('flipped');
            });
        },


        /**
         * Toggle about us section
         */
        __toggleAbout: function() {
            wntrTheme.body.find('.about-toggle-about').on('click', function() {
                $(this).addClass('toggle-active');
                wntrTheme.body.find('.about-toggle-contact').removeClass('toggle-active');
                wntrTheme.body.find('.about-toggle-membership').removeClass('toggle-active');
                wntrTheme.body.find('.about-us').show();
                wntrTheme.body.find('.about-contact').hide();
                wntrTheme.body.find('.about-membership').hide();

                $("html, body").animate({ scrollTop: $('.about-us').offset().top - 50 }, 400);
            });

            wntrTheme.body.find('.about-toggle-membership').on('click', function() {
                $(this).addClass('toggle-active');
                wntrTheme.body.find('.about-toggle-contact').removeClass('toggle-active');
                wntrTheme.body.find('.about-toggle-about').removeClass('toggle-active');
                wntrTheme.body.find('.about-membership').show();
                wntrTheme.body.find('.about-us').hide();
                wntrTheme.body.find('.about-contact').hide();

                $("html, body").animate({ scrollTop: $('.about-membership').offset().top - 50 }, 400);
            });

            wntrTheme.body.find('.about-toggle-contact').on('click', function() {
                $(this).addClass('toggle-active');
                wntrTheme.body.find('.about-toggle-membership').removeClass('toggle-active');
                wntrTheme.body.find('.about-toggle-about').removeClass('toggle-active');
                wntrTheme.body.find('.about-contact').show();
                wntrTheme.body.find('.about-us').hide();
                wntrTheme.body.find('.about-membership').hide();

                $("html, body").animate({ scrollTop: $('.about-contact').offset().top - 50 }, 400);
            });
        },


        /**
         * Disable contact form fields
         */
        __disableContactFormField: function () {
            if (wntrTheme.body.find('.membership-subject select').length > 0) {
                wntrTheme.body.find('.membership-subject select').attr('disabled', 'disabled');
            }

            if (wntrTheme.body.find('.contact-subject select').length > 0) {
                wntrTheme.body.find('.contact-subject select').attr('disabled', 'disabled');
            }
        },

        /**
         * Init slick
         */
        __initSlick: function() {
            const event_carousel = wntrTheme.body.find('.header-background-events-column');

            if (event_carousel.length > 0) {
                event_carousel.slick({
                    arrows: false,
                    dots: false,
                    infinite: true,
                    pauseOnFocus: false,
                    vertical: true,
                    verticalSwiping: true,
                    autoplay: true,
                    autoplaySpeed: 3000
                });

                event_carousel.show();
            }
        },

        /**
         * Hide video controls on safari
         */
        __hideControlsOnSafari: function() {
            const userAgent = window.navigator.userAgent;

            if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                const video = wntrTheme.body.find('#header-movie');
                if (video.length > 0) {
                    video.hide();
                }
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);